mpangoApp.factory('Muser',['$http', function($http) {
	return{
		getUsers : function() {
			return $http.get('index.php/api/getuser');
		},
		getEventusers : function() {
			return $http.get('index.php/api/geteventusers');
		},
		postUser : function(userdata) {
			return $http({
				method: 'POST',
				url: 'index.php/api/postuser',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':userdata}
			
			});
		},
		updateUser : function(userdata,formname) {
			return $http({
				method: 'POST',
				url: 'index.php/api/updateuser',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':userdata, 'formname':formname}
			});
		},
		checkPass : function(oldpass) {
			return $http({
				method: 'POST',
				url: 'index.php/api/checkpass',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':oldpass}
			
			});
		},
		uchangePass : function(userdata) {
			return $http({
				method: 'POST',
				url: 'index.php/api/uchangepass',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':userdata}
			
			});
		},
		pReset : function(userdata) {
			return $http({
				method: 'POST',
				url: 'index.php/api/pwdreset',
				data: userdata
			});
		},
	}
}]);